import React from "react";
import { FieldState } from "formstate";
import settingsStyles from "../../../../../../styles/settings.css";
import { intl } from "@fidget/common/i18n/TypedIntl";
import { GroupNameInput } from "./groupNameInput";
import tagGroupsStyles from "../tagGroups.css";
import styles from "./groupNameInputColumn.css";
import classNames from "classnames";
import { staticConfig } from "@fidget/common/config/static-config";

interface Props {
  field: FieldState<string>;
}
export const GroupNameInputColumn = ({ field }: Props) => {
  return (
    <div className={tagGroupsStyles.column}>
      <p className={classNames(settingsStyles["form-label-font"], styles["margin-group-label"])}>
        {intl.formatMessage("settings.tagGroups.form.name.label")}
      </p>
      <GroupNameInput field={field} autoFocus />
      <p
        className={classNames(
          settingsStyles["form-label-font"],
          styles["margin-group-desc"],
          settingsStyles["input-max-width"]
        )}
      >
        {intl.formatMessage("settings.tagGroups.form.name.description", {
          limit: staticConfig.tagGroupNameMaxCharacters
        })}
      </p>
    </div>
  );
};
